import script from "./kalio-slack-office-hour.vue?vue&type=script&setup=true&lang=js"
export * from "./kalio-slack-office-hour.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__